import React from "react";
import { StyledSnackbar } from "../../components/common/AppSnackbar";

export default function RequiredFieldsSnackbar({
  open,
  onClose,
  requiredList = [],
  requiredListTable = {},
}) {
  if (!open) return null;

  const requiredFieldsCount =
    requiredList.length + Object.keys(requiredListTable).length;

  const message =
    requiredFieldsCount === 1
      ? "Please answer 1 required question before submitting."
      : `Please answer ${requiredFieldsCount} required questions before submitting.`;

  return (
    <StyledSnackbar
      open={open}
      message={message}
      severity="error"
      onClose={onClose}
      autoHideDuration={6000}
    />
  );
}
